import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import lang from '@blade-sxp/portrait-center/lang/index';
import ZoneTab from '@blade-sxp/portrait-center/pages/components/zone-tab/index.vue';
import DataView from '@blade-sxp/portrait-center/pages/components/data-view/index.vue';
import { PortraitCenterModule } from '@blade-sxp/portrait-center/store/index';
import { LoginModule } from '@blade/common/store/login';
let portraitCenter = class portraitCenter extends Vue {
    permissons = [];
    listCard = [];
    firstTabName = '';
    created() {
        PortraitCenterModule.getActiveTab('');
        PortraitCenterModule.getCurrentZoneId(0);
    }
    mounted() {
        this.permissons = LoginModule.permissions || [];
        let permissionCard;
        // 获取画像中心子权限
        permissionCard = this.permissons.filter((item) => item?.code === this.$route.meta.code)[0]
            ?.subPermissions;
        this.listCard = permissionCard
            .filter((item) => item?.enable)
            .map((item) => {
            return {
                label: item?.name,
                name: item?.code === '0801' ? 'VIRTUAL_AREA' : 'MAP',
            };
        });
        this.firstTabName = this.listCard[0].name;
        PortraitCenterModule.getActiveTab(this.listCard[0].name);
    }
};
portraitCenter = __decorate([
    Component({
        name: 'portraitCenter',
        components: { ZoneTab, DataView },
        i18n: { messages: lang },
    })
], portraitCenter);
export default portraitCenter;
